import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import { FinancialItemEntityPriceListingImportFileHelperContainer } from '../../../../../../models';

@Injectable({
  providedIn: 'root'
})
export class FinancialItemEntityPriceListingImportFileHelperService extends BaseApiTemplateService<FinancialItemEntityPriceListingImportFileHelperContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'item-entity-pricing/import-file/helper';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'item-entity-pricing/import-file/helper' + '/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'item-entity-pricing/import-file/helper' + '/backoffice-ep';
    this.httpClient = http;
  }
}
